<div class="bg-primary p-4 pt-1 text-sm">
    <p-divider></p-divider>
    <div class="grid">
        <div class="col-12 md:col-6 pl-3">
            <i class="fa-regular fa-copyright"></i>
            2023 Stadtwerke Saarlouis GmbH
        </div>
        <div class="col-12 md:col-6 pr-3 text-right">
            <a href="https://www.swsls.de/impressum.html" target="_blank" class="text-white">Impressum</a>
            |
            <a href="https://www.swsls.de/datenschutz-glasfaser.html" target="_blank" class="text-white">Datenschutz</a>
            |
            <a href="https://www.swsls.de/oeffnungszeiten.html" target="_blank" class="text-white">Kontakt</a>
        </div>
    </div>
</div>